export const TOTAL_CONTACTS = [1, 2, 3, 4];
export const KEYS_TO_CLEAR = [
	"clientContactId",
	"role",
	"title",
	"firstName",
	"lastName",
	"phoneNumber",
	"emailAddress",
	"languageCode",
	"linkedin",
	"note"
];
export const KEYS_TO_POST = [...KEYS_TO_CLEAR,
	"isMainStrategic",
	"contactIndex"
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/helpers/contactDataHelper.js